import { Wallet, Receipt, Landmark, TrendingUp, PiggyBank, Shield, Home, Coins, BarChart3, GraduationCap, Scale, Globe, CreditCard, HeartHandshake } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const TopicsSection = () => {
  const { t } = useLanguage();

  const topics = [
    { icon: Wallet, key: "topics.budget" },
    { icon: Receipt, key: "topics.taxes" },
    { icon: Landmark, key: "topics.pillar3a" },
    { icon: TrendingUp, key: "topics.etfs" },
    { icon: PiggyBank, key: "topics.saving" },
    { icon: Shield, key: "topics.insurance" },
    { icon: Home, key: "topics.realestate" },
    { icon: Coins, key: "topics.crypto" },
    { icon: BarChart3, key: "topics.investing" },
    { icon: GraduationCap, key: "topics.basics" },
    { icon: Scale, key: "topics.debt" },
    { icon: CreditCard, key: "topics.credit" },
    { icon: Globe, key: "topics.sustainability" },
    { icon: HeartHandshake, key: "topics.pension" },
  ];

  return (
    <section className="py-24 bg-ink-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <div className="eyebrow mb-4">{t("eyebrow.topics")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-white mb-4">{t("topics.title")}</h2>
          <p className="text-lg text-white/60">{t("topics.sub")}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2.5 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <div key={i} className="flex items-center gap-2 bg-ink-700 border border-white/[0.06] px-4 py-2.5 rounded-full hover:border-violet/40 hover:bg-violet/5 transition-colors duration-200">
              <topic.icon className="h-4 w-4 text-violet" />
              <span className="text-sm font-medium text-white/85">{t(topic.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopicsSection;
